import surveyEndpoint from 'app/api/services/surveyEndpoint';
import notification from 'app/config/notification';
import { validateDocumentsDescription } from '../functions';
import vehiclesEndpoint from '../../../api/services/vehiclesEndpoint';
import { SERVICES_CODES } from '../../../config/services';

export const validateVehicleAge = async ({ service, plate, subSystem, chassiYear, deUtilizacao }) => {
  const params = {};
  if (service) params.cdServico = service.cdServico;
  if (plate) params.dePlaca = plate;
  if (chassiYear) params.nuAnoFabricacao = chassiYear;
  if (subSystem) params.cdSubSistema = subSystem.cdSubSistema;
  if (deUtilizacao) params.deUtilizacao = deUtilizacao;
  try {
    const response = await surveyEndpoint.maxAgeVehicle(params);
    if (response.status === 200 && response.data) {
      return response.data;
    }
  } catch (error) {}
  return false;
};

export const validateVehicleList = async (intl, cdServico, cdSolicitacao, veiculos) => {
    const validate = await Promise.all(veiculos.map(async (veiculo, index, array) => {
      if (!veiculo.deRenavam) return true;
      return await validateVehicle(intl, cdServico, cdSolicitacao, array, index, 'deRenavam', veiculo.deRenavam);
    }));
    return validate.every(Boolean);
};

export const validateVehicle = async (intl, cdServico, cdSolicitacao, veiculos, index, name, value) => {
  name = name.replace(/^de/, '');
  const isInclusao = cdServico === SERVICES_CODES.INCLUSAO_VEICULOS ||
    cdServico === SERVICES_CODES.INCLUSAO_VEICULOS_SEM_CRC;

  let validate = validateVehicleAlreadyListed(intl, veiculos, index, name, value);
  if (isInclusao && validate === true) {
    validate = await validateVehicleAlreadyExist(intl, name, value);
  }
  if (validate === true) {
    validate = await validateVehicleAlreadyRequested(intl, cdServico, cdSolicitacao, name, value);
  }
  return validate;
};

const validateVehicleAlreadyListed = (intl, veiculos, index, name, value) => {
  const listed = veiculos.some((v, i) => {
    if (i === index) return false;
    return ((v.dePlaca === value) || (v.deRenavam === value));
  });

  if (listed) {
    notification(intl.formatMessage(
      { id: 'MESSAGES.SERVICE.FORMS.VEHICLE_ALREADY_LISTED' }, { name, value }
    ), { toastId: `VEHICLE_ALREADY_LISTED_${value}`, type: 'error' });
    return false;
  }
  return true;
};

const validateVehicleAlreadyExist = async (intl, name, value) => {
  const exist = await vehiclesEndpoint.existeComOperadorAtivo(value);

  if (exist && exist.status === 200 && exist.data) {
    notification(intl.formatMessage(
      { id: 'MESSAGES.SERVICE.FORMS.VEHICLE_ALREADY_EXISTS' }, { name, value }
    ), { toastId: `VEHICLE_ALREADY_EXISTS_${value}`, type: 'error' });
    return false;
  }
  return true;
};

const validateVehicleAlreadyRequested = async (intl, cdServico, cdSolicitacao, name, value) => {
  const params = Number.isInteger(cdSolicitacao) ? { params: { cdServico, cdSolicitacao } } : { params : { cdServico }};
  const requested = await vehiclesEndpoint.existeSolicitacaoEmAndamento(value, params);

  if (requested && requested.status === 200 && !!requested.data) {
    const { data } = requested;
    notification(intl.formatMessage(
      { id: 'MESSAGES.SERVICE.FORMS.VEHICLE_ALREADY_REQUESTED' },
      { name, value, data }
    ), { toastId: `VEHICLE_ALREADY_REQUESTED_${data}`, type: 'error' });
    return false;
  }
  return true;
};

export const validateVehicleRequest = ({ values, intl, isInternalForm, survey }) => {
  let vehicles = values.veiculos;
  if(survey) vehicles = values.vistoriaVeiculos;

  if (!vehicles || vehicles?.length === 0) {
    notification(intl.formatMessage({ id: 'MESSAGES.SERVICE.FORMS.MISSING_MANDATORY_VEHICLES' }), {
      toastId: 'MISSING_MANDATORY_VEHICLES',
      type: 'warning',
    });
    return false;
  } else {
    let error = false;
    vehicles.forEach(v => {
      if (!v.documentos || v.documentos?.length === 0) {
        error = true;
      }
    });
    if (error) {
      notification(
        intl.formatMessage({ id: 'MESSAGES.SERVICE.FORMS.MISSING_MANDATORY_VEHICLES' }),
        {
          toastId: 'MISSING_MANDATORY_VEHICLES',
          type: 'warning',
        }
      );
      return false;
    }
  }

  const docsExtrasValidation = validateDocumentsDescription(values.documentos);
  if (!docsExtrasValidation && !isInternalForm) {
    notification(
      intl.formatMessage({ id: 'MESSAGES.SERVICE.FORMS.DOCUMENT_DESCRIPTION_REQUIRED' }),
      {
        toastId: 'MESSAGES.SERVICE.FORMS.DOCUMENT_DESCRIPTION_REQUIRED',
        type: 'error',
      }
    );
    return false;
  }

  return true;
};
